import { FetchSyncPayload, SyncAction, SyncActionPayload, SyncResponse } from './sync.state';

export const CREATE_SYNC_REQUEST = 'CREATE_SYNC_REQUEST';
export const FETCH_SYNC_REQUEST = 'FETCH_SYNC_REQUEST';
export const CREATE_SYNC_SUCCESS = 'CREATE_SYNC_SUCCESS';
export const CREATE_SYNC_FAILURE = 'CREATE_SYNC_FAILURE';
export const FETCH_SYNC_SUCCESS = 'FETCH_SYNC_SUCCESS';
export const FETCH_SYNC_FAILURE = 'FETCH_SYNC_FAILURE';
export const RESET_SYNC_STATE = 'RESET_SYNC_STATE';

type SyncResultAction = (payload?: SyncActionPayload | FetchSyncPayload) => SyncAction;
type CreateSyncResultAction = (payload: SyncResponse) => SyncAction;
type FetchSyncStatusSuccess = (payload: { status: string; value: SyncResponse }[]) => SyncAction;

export const syncData: SyncResultAction = (payload) => {
  return {
    type: CREATE_SYNC_REQUEST,
    payload,
  };
};

export const fetchSyncStatuses: SyncResultAction = (payload) => {
  return {
    type: FETCH_SYNC_REQUEST,
    payload,
  };
};

export const resetSyncStatus: SyncResultAction = () => {
  return {
    type: RESET_SYNC_STATE,
  };
};

export const createSyncSuccess: CreateSyncResultAction = (payload) => {
  return {
    type: CREATE_SYNC_SUCCESS,
    payload,
  };
};

export const createSyncFailure: SyncResultAction = (payload) => {
  return {
    type: CREATE_SYNC_FAILURE,
    payload,
  };
};

export const fetchSyncSuccess: FetchSyncStatusSuccess = (payload) => {
  return {
    type: FETCH_SYNC_SUCCESS,
    payload,
  };
};

export const fetchSyncFailure: SyncResultAction = (payload) => {
  return {
    type: FETCH_SYNC_FAILURE,
    payload,
  };
};
